import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { map, tap, concatMap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Pagination } from '@core/models/pagination.model';
import { PromotionCurrency } from '@core/models/promotion-currency.model';

@Injectable()
export class PromotionCurrencyDataService extends DefaultDataService<PromotionCurrency> {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
      super('PromotionCurrency', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<PromotionCurrency[]> {
    return this.http.get<ApiResponse>('/promotioncurrency').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getById(id: number): Observable<PromotionCurrency>{
    return this.http.get<ApiResponse>(`/promotioncurrency/${id}`).pipe(
      map(res => res.data.rows)
    );
  }

  add(promotionCurrency: PromotionCurrency): Observable<PromotionCurrency>{
    return this.http.post<ApiResponse>(`/promotioncurrency`, promotionCurrency).pipe(
      tap( res => this.messages$.next(res.message)),
      concatMap((entity) => this.http.get(`/promotioncurrency/${entity.data.rows.id}`).pipe(
        map((row: ApiResponse) => row.data.rows)
      ))
    );
  }

  getWithQuery(pageParam: string): Observable<PromotionCurrency[]>{
    return this.http.get<ApiResponse>(`/promotioncurrency${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    )
  }

  private paginationInit(res: any) {
    if(res) {
      this.pagination = res.data.paginations;
    }
  }

}
